<template>
  <div>
    <Modal :footer-hide="false" :mask-closable="false" v-model="show" :title="row.orgName" :width="1000"  @on-cancel="clearForm()">
      <span class="markerpen">
        <font v-if="row.govAuthStatus == 100" class="CL5">监管待审</font>
        <font v-if="row.govAuthStatus == 200" class="CL4">监管通过</font>
        <font v-if="row.govAuthStatus == 300" class="CL6">监管拒审</font>
      </span>
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td><b>运输单位</b></td>
          <td>{{ row.orgName }}</td>
        </tr>
        <tr>
          <td><b>通讯地址</b></td>
          <td>{{ row.org.addressFull }}</td>
        </tr>
        <tr>
          <td><b>联系姓名</b></td>
          <td>{{ row.org.contactName }}</td>
        </tr>
        <tr>
          <td><b>联系电话</b></td>
          <td>{{ row.org.contactTel }}</td>
        </tr>
        <tr>
          <th>运输权限</th>
          <th></th>
        </tr>
        <tr>
          <td><b>运输区域</b></td>
          <td>
            <span> {{ row.authAreaNameFull }}</span>
          </td>
        </tr>
        <tr>
          <td><b>卸车许可</b></td>
          <td v-if="!$isblank(row.canUnloadCar)">
            <span v-if="row.canUnloadCar == 100">仅自己接收（清运司机只能运输到自己单位,不能运输到三方接收点）</span>
            <span v-if="row.canUnloadCar == 200">仅三方接收（清运司机只能运输到三方接收点,不能运输到自己单位）</span>
            <span v-if="row.canUnloadCar == 300">自己及三方（清运司机既可运输到自己单位,也可以运输到三方接收点）</span>
          </td>
          <td v-else>
            <span class="CL11"><i class="MR3 iconfont icon-wenhao-quan"></i>未设置运输卸车许可,不可参与运输</span>
          </td>
        </tr>
        <tr>
          <td><b>开通时间</b></td>
          <td>{{ $timeFmt(row.created, "YYYY年MM月DD日 HH分mm秒") }} {{ row.from }}</td>
        </tr>

        <!---运输资质-->
        <tr>
          <th>运输资质</th>
          <th style="text-align: right">
            <span class="CL4" v-if="row.status == 100"><i class="MR3 iconfont icon-tongyi"></i>运输权限已开通</span>
            <span class="CL1" v-if="row.status == 200"><i class="MR3 iconfont icon-wenhao-quan"></i>运输权限已关闭</span>
            <span class="CL1" v-if="row.status == 300"><i class="MR3 iconfont icon-wenhao-quan"></i>运输权限待提审</span>
            <span class="CL1" v-if="row.status == 400"><i class="MR3 iconfont icon-wenhao-quan"></i>运输权限审核中</span>
            <span class="CL1" v-if="row.status == 500"><i class="MR3 iconfont icon-wenhao-quan"></i>运输权限已拒绝</span>
          </th>
        </tr>
        <tr v-for="(item, index) in row.orgAllQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="$isblank(row.orgAllQualification)">
          <td style="text-align: center" colspan="10">暂未完善相关资质</td>
        </tr>
        <!---运输资质 end-->

        <!--审核日志-->
        <tr>
          <th>审核记录</th>
          <th colspan="10"></th>
        </tr>
        <tr v-if="$isblank(row.log)">
          <td colspan="10">暂无审核记录</td>
        </tr>
        <tr v-if="!$isblank(row.log)">
          <td colspan="10">
            <div style="text-align: left; padding: 5px; border-radius: 5px; margin: 5px 0; background: #f5f5f5" v-for="(item, index) in row.log" :key="index">
              <p>{{ $timeFmt(item.created, "YYYY年MM月DD日 HH:mm") }}➥行政单位:{{ item.orgName }}➥账号:{{ item.username }}➥通过:{{ item.app }}</p>
              <p>{{ item.content }}</p>
            </div>
          </td>
        </tr>
        <!---审核日志 end-->
        
      </table>

      <!---操作区域-->
      <div slot="footer">
        <Button type="success" v-if="scene == 'sceneGov'" @click="$refs.OSgovAuth.hiPop(row.id, 'govAuthYunshu')">监管审核</Button>
        <Button type="primary" @click="$goQiyeBigscreen(row.orgId, 5)">登录该企业大屏</Button>
      </div>
      <!---操作区域 end-->
    </Modal>

    <!--弹窗组件区-->
    <OSgovAuth ref="OSgovAuth" @success="reDetailed()"></OSgovAuth>
    <!--弹窗组件区 end-->
  </div>
</template>
<script>
import OSgovAuth from "@/component/OSgovAuth/OSgovAuth";
export default {
  components: {
    OSgovAuth,
  },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      show: false,
      isUpdate: false,
      row: {},
    };
  },
  props: {
    scene: {
      type: String,
      required: false,
      default: "sceneUsed",
    },
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgyunshuDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:刷新详情
    // +----------------------------------------------------------------------
    reDetailed() {
      this.hiPop(this.row);
      this.isUpdate = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理关闭
    // +----------------------------------------------------------------------
    clearForm() {
      this.show = false;
      this.row = {};
      if (this.isUpdate) {
        this.$emit("success");
        this.isUpdate = false;
      }
    },
  },
};
</script>
